import { Box, List } from '@material-ui/core'
import { DrawerTopBar } from './DrawerTopBar'
import { StyledFilterDrawerItem, StyledJobsFilterDrawerContainer } from './styles'
import { filterCountryList } from 'pages/content/components/jobs/components/template/JobFormMobile/data'
import { SetStateAction } from 'react'

interface IDrawerFilterOptionsProps {
  onValueChange: (e: any) => void
  setDrawerOpen: (value: SetStateAction<boolean>) => void
  list: { label?: string; value?: string }[]
  name: string
  label?: string
}

export const DrawerFilterOptions = ({ onValueChange, setDrawerOpen, label, list, name }: IDrawerFilterOptionsProps) => {
  return (
    <StyledJobsFilterDrawerContainer display="grid" gridTemplateRows="1fr 10fr">
      <DrawerTopBar label={label} />
      <Box width="100%" height="100%" overflow='auto'>
        <List>
          {list?.map(item => {
            return (
              <StyledFilterDrawerItem
                button
                onClick={() => {
                  onValueChange({
                    target: {
                      name: name,
                      value: item?.value
                    }
                  })
                  setDrawerOpen(false)
                }}
              >
                {item?.label}
              </StyledFilterDrawerItem>
            )
          })}
        </List>
      </Box>
    </StyledJobsFilterDrawerContainer>
  )
}
